import React, { Fragment, useState, useEffect } from "react";

import { ResultProvider } from "../../dataProvider/results";
import { getResultOrigin } from "../../dataProvider/origin";
import { TYPES, SUBTYPES } from "../../envs/core";
import "./trendGraphContainer.scss";
import Header from "../../components/header";
import TrendGraph from "./../../components/trendGraph";

const TrendGraphContainer = ({ match }) => {
  const { year, type, electionNumber, placesIds } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  return (
    <Fragment>
      <Header>
        <h2>TENDENCIAS EN: COMUNIDAD DE MADRID</h2>
      </Header>
      <div className="trendgraphContainer">
        {resultOrigin && resultOrigin.primary && (
          <ResultProvider
            electionPlace={placesIds}
            active={resultOrigin.primary.active}
            year={year}
            type={type}
            subtype={
              type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
            }
            electionNumber={electionNumber}
            placeId={placesIds}
          >
            {dataResult => <TrendGraph data={dataResult} />}
          </ResultProvider>
        )}
      </div>
    </Fragment>
  );
};

export default TrendGraphContainer;
